import { registerPlugin } from '@capacitor/core';
const WidgetImageStore = registerPlugin('WidgetImageStore', {
    web: () => import('./web').then((m) => new m.WidgetImageStoreWeb()),
});
export * from './definitions';
export { WidgetImageStore };
//# sourceMappingURL=index.js.map